import AgentInfoService from "../../../../../../services/reports/agent-info-service.js";
import {useQuery} from "@tanstack/react-query";
import ProjectUtils from "../../../../../../utils/project-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";
import teamService from "../../../../../../services/web/team-service.js";
import PrintSection from "../../../../../../components/print-options-modal/print-section.jsx";

export default function AgentPersonal({ data, img = true, visible }) {
    const agentId = data?.id;
    const agentData = data?.general ?? {};
    const profile = agentData?.profile ?? {};
    const address = data?.general?.address ?? {};

    const { data: agentImg } = useQuery({
        queryKey: ["agent-img", agentId],
        queryFn: () => AgentInfoService.getImage(agentId),
        enabled: !!agentId,
    });

    const { data: teams } = useQuery({
        queryKey: ["teams"],
        queryFn: async () => {
            const { data } = await teamService.getAll();
            return data ?? [];
        },
    });

    const teamName = teams?.find(team => team.value === agentData?.userTeamId)?.label ?? "";

    const eduLevelMap = {
        illiterate: "Não alfabetizado",
        elementarySchool: "Fundamental",
        highSchool: "Médio",
        university: "Superior",
        postGraduate: "Pós-graduação",
        master: "Mestrado",
        doctorate: "Doutorado",
    }

    const sexMap = {
        MALE: "Masculino",
        FEMALE: "Feminino",
    }

    const personalInfo = [
        {
            label: "Nome",
            value: agentData?.name ?? "",
            span: 3
        },
        {
            label: "CPF",
            value: ProjectUtils.formatCpfToView(agentData.cpf ?? ""),
        },
        {
            label: "E-mail",
            value: agentData?.email ?? "",
            span: 2
        },
        {
            label: "Sexo",
            value: sexMap[profile?.sex] ?? "",
        },
        {
            label: "Nascimento",
            value: ReportUtils.formatDateOnly(profile?.dtBirth ?? ""),
        },
        {
            label: "Naturalidade",
            value: profile?.nationality ?? "",
        },
        {
            label: "Escolaridade",
            value: eduLevelMap[profile?.educationLevel] ?? "",
        },
        {
            label: "Estado civil",
            value: profile?.maritalStatus ?? "",
        },
        {
            label: '',
            value: ' '
        },
        {
            label: "Mãe",
            value: profile?.mother ?? "",
        },
        {
            label: "Pai",
            value: profile?.father ?? "",
        },
        {
            label: "Fator sanguíneo",
            value: profile?.bloodFactor ?? "",
        },
        {
            label: "Data da foto",
            value: ReportUtils.formatDateOnly(profile?.pictureDate ?? ""),
        },
        {
            label: "Canhoto",
            value: profile?.leftHanded === true ? "Sim" : profile?.leftHanded === false ? "Não" : "",
        }
    ]

    const agentInfo = [
        {
            subTitle: "Dados do agente",
            items: [
                {
                    label: "Nome de guerra",
                    value: agentData?.nameWar ?? "",
                },
                {
                    label: "Número funcional",
                    value: agentData?.employeeCode ?? "",
                },
                {
                    label: "Patentes",
                    value: agentData?.rank ?? "",
                },
                {
                    label: "Equipe",
                    value: teamName ?? "",
                },
                {
                    label: "Setor",
                    value: profile?.sector ?? "",
                },
                {
                    label: "Admissão",
                    value: ReportUtils.formatDateOnly(profile?.admission ?? ""),
                },
                {
                    label: "Data desligamento",
                    value: ReportUtils.formatDateOnly(profile?.terminationDate ?? ""),
                },
                {
                    label: "Prazo contratual",
                    value: ReportUtils.formatDateOnly(profile?.contractualTerm ?? ""),
                }
            ]
        }
    ]

    const addressInfo = [
        {
            subTitle: "Endereço",
            items: [
                {
                    label: "Tipo",
                    value: address?.type ?? "",
                },
                {
                    label: "Logradouro",
                    value: address?.address ?? "",
                },
                {
                    label: "Número",
                    value: address?.number ?? "",
                },
                {
                    label: "Complemento",
                    value: address?.complement ?? "",
                },
                {
                    label: "Bairro",
                    value: address?.neighborhood ?? "",
                },
                {
                    label: "Município",
                    value: address?.city ?? "",
                },
                {
                    label: "CEP",
                    value: address?.zipcode ?? "",
                }
            ]
        }
    ]

    const info = [
        ...personalInfo,
        ...agentInfo,
        ...addressInfo
    ];

    return (
        <div className="space-y-4">

            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f]">
                Informações pessoais
            </h2>

            <div className={`${img === true ? "grid grid-cols-[225px_1fr] gap-x-5 gap-y-2" : "flex flex-row"}`}>

                { img === true ? (
                    <>

                        <img
                            src={agentImg ?? ""}
                            alt="Face do agente"
                            className="w-[225px] h-[225px] rounded object-cover"
                        />

                        <InfoGrid title="" items={personalInfo} columns={3} labelClassName={'text-[#4F4F4F] text-[13px]!'} contentClassName={'space-y-1'} className={'px-0! pl-4!'}/>

                        <div className="col-span-2">
                            <InfoGrid title="" items={agentInfo} columns={3} className={"px-0! pt-0!"} labelClassName={'text-[#4F4F4F] text-[13px]!'} contentClassName={'space-y-1'}/>

                           <PrintSection visible={visible}>
                               <InfoGrid title="" items={addressInfo} columns={3} className={"px-0! pt-2!"} labelClassName={'text-[#4F4F4F] text-[13px]!'} contentClassName={'space-y-1'}/>
                           </PrintSection>
                        </div>

                    </>
                ) : (

                    <InfoGrid title="" items={info} columns={3} className={"px-0!"} labelClassName={'text-[#4F4F4F] text-[13px]'}/>

                )}

            </div>

        </div>
    )
}
